import styles from './Menu.desktop.module.css';
import React from 'react';
import { FaBagShopping, FaChartPie, FaRightFromBracket, FaUserGear } from 'react-icons/fa6';
import CanEditMarket from '../../../security/CanEditMarket.ts';
import MenuGeneralView from './Menu.General.view.tsx';
import { useMenuController } from '../Menu.controller.ts';
import AreYouSureDialogView from '../../../dialogs/are-you-sure-dialog/AreYouSureDialog.view.tsx';
import { useTranslation } from 'react-i18next';
import CanViewReporting from '../../../security/CanViewReporting.ts';

export default function MenuAdministrationView() {
  const { t } = useTranslation();
  const {
    handleMarketManagementClick,
    handleUserManagementClick,
    handleReportingClick,
    handleLogoutAllClick,
    handleLogoutNoClick,
    handleLogoutYesClick,
    isAreYouSureDialogOpen,
  } = useMenuController();

  return (
    <>
      {isAreYouSureDialogOpen && (
        <AreYouSureDialogView
          message={t('ui.userLogoutMessage')}
          handleNo={handleLogoutNoClick}
          handleYes={handleLogoutYesClick}
        />
      )}

      <MenuGeneralView>
        {/* Market Management */}
        {CanEditMarket() && (
          <>
            <div className={styles.menuItemContainer} onClick={handleMarketManagementClick}>
              <div className={styles.menuItemIconContainer}>
                <FaBagShopping className={styles.icon} />
              </div>
              <div className={styles.menuItemLabelContainer}>
                <p className={styles.menuItemLabel}>{t('ui.marketManagement')}</p>
              </div>
            </div>

            <hr className={styles.horizontalSeparator} />
          </>
        )}

        {/* User Management */}
        {CanEditMarket() && (
          <>
            <div className={styles.menuItemContainer} onClick={handleUserManagementClick}>
              <div className={styles.menuItemIconContainer}>
                <FaUserGear className={styles.icon} />
              </div>
              <div className={styles.menuItemLabelContainer}>
                <p className={styles.menuItemLabel}>{t('ui.userManagement')}</p>
              </div>
            </div>

            <hr className={styles.horizontalSeparator} />
          </>
        )}

        {/* Reporting */}
        {CanViewReporting() && (
          <>
            <div className={styles.menuItemContainer} onClick={handleReportingClick}>
              <div className={styles.menuItemIconContainer}>
                <FaChartPie className={styles.icon} />
              </div>
              <div className={styles.menuItemLabelContainer}>
                <p className={styles.menuItemLabel}>{t('ui.reporting')}</p>
              </div>
            </div>

            <hr className={styles.horizontalSeparator} />
          </>
        )}

        {/* Admin Logout */}
        <>
          <div className={styles.menuItemContainer} onClick={handleLogoutAllClick}>
            <div className={styles.menuItemIconContainer}>
              <FaRightFromBracket className={styles.icon} />
            </div>
            <div className={styles.menuItemLabelContainer}>
              <p className={styles.menuItemLabel}>{t('ui.userLogoutButton')}</p>
            </div>
          </div>

          <hr className={styles.horizontalSeparator} />
        </>
      </MenuGeneralView>
    </>
  );
}
